export default __webpack_public_path__ + "static/media/image3.6301f518.webp";